module.exports = __webpack_public_path__ + "img/no_advert.cf892c86.png";